import { render, staticRenderFns } from "./en.svg?vue&type=template&id=88eb29be&"
var script = {}


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports